export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Bold.59da1e8.woff2";